/*------------------------------------*\
    account
\*------------------------------------*/
module.exports = function(){





    /*------------------------------------*\
        elements
    \*------------------------------------*/
    var el = {
        changeForm: '.js-basic-info-change-form',
        changeBtn: '.js-basic-info-change-btn'
    };




    /*------------------------------------*\
        Password Form
    \*------------------------------------*/
    if ( $(el.changeForm).length ) {
        $(el.changeForm).parsley();
    }


    var originalEmail = $(el.changeForm).find('input[name="Email"]').val();


    //domtest@sharklasers.com


    $(el.changeForm).on('submit', function(event) {
        event.preventDefault();
        var form = $(this);

        //var inputEmail = form.find('input[name="Email]');


        if ( form.parsley().isValid() ) {


            $.ajax({
                url: form.attr('action'),
                type: form.attr('method'),
                dataType: 'json',
                headers: {
                    Authorization: 'Bearer ' + Cookies.get('JWT_ACCESS_TOKEN'),
                    Accept: 'application/json'
                },
                data: form.serialize(),
                complete: function(jqXHR, textStatus){

                },

                success: function(data, textStatus, jqXHR){

                    form.find('.js-form-callback')
                        .text('Information changed successfully.')
                        .addClass('is-visible')
                        .removeClass('is-error')
                        .addClass('is-success');

                    if (data.EmailChanged == 'true') {
                        alertify.alert('Because you\'ve changed your email we\'ve logged you out. Please login again using your new email.', function(){
                            location.reload();
                        });
                    }

                },

                error: function(jqXHR, textStatus, errorThrown){

                    form.find('.js-form-callback')
                        .text(jqXHR.responseJSON.msg)
                        .addClass('is-visible')
                        .removeClass('is-success')
                        .addClass('is-error');

                },


            });


        }

    });








}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/integration/change-basic-info.js